import * as React from "react";
import { Alert } from "reactstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";

const alertBackgroundColorDictionary: { [key: string]: string } = {
  success: "lightCloud",
  error: "errorInfo",
};

const alertTextColorDictionary: { [key: string]: string } = {
  success: "primary",
  error: "danger",
};

export const Banner: React.FC<{
  type: "success" | "error";
  text: string;
  onClose: () => void;
}> = ({ type, text, onClose }) => {
  return (
    <Alert
      className={`bg-${alertBackgroundColorDictionary[type]} text-${alertTextColorDictionary[type]} border border-${alertTextColorDictionary[type]}`}
      toggle={onClose}
    >
      <AiOutlineInfoCircle
        className={`me-2 text-${alertTextColorDictionary[type]}`}
        size={15}
      />
      <span className={`text-small text-${alertTextColorDictionary[type]}`}>
        {text}
      </span>
    </Alert>
  );
};
